import DATE_RANGES from 'src/constants/DATE_RANGES';

export const TIME_RANGES = [
    {
        label: 'today',
        value: DATE_RANGES.today,
    },
    {
        label: 'yesterday',
        value: DATE_RANGES.yesterday,
    },
    {
        label: 'month',
        value: DATE_RANGES.month,
    },
    {
        label: 'pastMonth',
        value: DATE_RANGES.pastMonth,
    },
    {
        label: 'year',
        value: DATE_RANGES.year,
    },
    {
        label: 'pastYear',
        value: DATE_RANGES.pastYear,
    },
];
